import React, {useEffect, Suspense, lazy } from "react";
import Banner from "../components/Banner";

const Faq = lazy(() => import("../components/Faq.js"));
const Benefits = lazy(() => import("../components/Benefits.js"));
const Goals = lazy(() => import("../components/Goals.js"));
const Footer = lazy(() => import("../components/Footer.js"));



function Homepage() {

  useEffect(() => {
        (function (c, l, a, r, i, t, y) {
          c[a] =
            c[a] ||
            function () {
              (c[a].q = c[a].q || []).push(arguments);
            };
          t = l.createElement(r);
          t.async = 1;
          t.src = "https://www.clarity.ms/tag/" + i;
          y = l.getElementsByTagName(r)[0];
          y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", "tqjggh89an");
      }, []);

      
  return (
    <Suspense fallback={<>Loading...</>}>
      <Banner />
      <Benefits />
      <Goals />
      <Faq />
      <Footer />
    </Suspense>
  );
}

export default Homepage;
